import classcat from "classcat";
import React from "react";

import { ConfirmationModal, IconX } from "@touchtech/web-baselayer-ui";

import EnlargeCarousel from "./EnlargeCarousel";
import css from "./EnlargeModal.module.css";
import useManageEnlargeModal from "./hooks/useManageEnlargeModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export type EnlargeRefType = { scale: number; reset: (delay?: number) => void };

const EnlargeModal = ({ isOpen, onClose }: Props) => {
  const {
    enlargedMedias,
    startModalTransition,
    enlargeRef,
    handleClose,
    handleOnCloseClick,
  } = useManageEnlargeModal({
    isOpen,
    onClose,
  });

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={handleOnCloseClick}
      className={classcat([
        css.modal,
        { [css.transition]: startModalTransition },
      ])}
    >
      <div className={css.header}>
        <button
          onClick={handleOnCloseClick}
          className={classcat([
            css.closeButtonContainer,
            { [css.transition]: startModalTransition },
          ])}
        >
          <IconX className={css.closeIcon} />
        </button>
      </div>
      <EnlargeCarousel
        enlargeRef={enlargeRef}
        initialSlide={enlargedMedias.initialIndex}
        medias={enlargedMedias.medias}
        onClose={handleClose}
        startTransition={startModalTransition}
      />
    </ConfirmationModal>
  );
};

export default EnlargeModal;
